import { useDispatch } from "react-redux";
import { bindActionCreators, createAction } from "@reduxjs/toolkit";

import { ActionType } from "./types/actionType";
import {
  SetPricePayload,
  GetSamplePayload,
  CreateSamplePayload,
  DeleteSamplePayload,
  UpdateSamplePayload,
  GetManySamplesPayload,
  CustomRequestPayload,
  ImportSamplesPayload,
  ExportSamplesPayload,
  PlaceCustomRequestPayload,
  GetManySamplesByIdPayload,
  GetManySamplesByLoincPayload,
} from './types/types';

const createSample = createAction<CreateSamplePayload>(
  ActionType.CREATE_SAMPLE
);

const updateSample = createAction<UpdateSamplePayload>(
  ActionType.UPDATE_SAMPLE
);

const deleteSample = createAction<DeleteSamplePayload>(
  ActionType.DELETE_SAMPLE
);

const retrieveSample = createAction<GetSamplePayload>(ActionType.GET_SAMPLE);

const cusomtRequest = createAction<CustomRequestPayload>(ActionType.CUSTOM_REQUEST);

const placeCustomRequest = createAction<PlaceCustomRequestPayload>(ActionType.PLACE_CUSTOM_REQUEST);

const importSamples = createAction<ImportSamplesPayload>(ActionType.IMPORT_SAMPLES);

const exportSamples = createAction<ExportSamplesPayload>(ActionType.EXPORT_SAMPLES);

const setPrice = createAction<SetPricePayload>(ActionType.SET_PRICE);

const retrieveManySamples = createAction<GetManySamplesPayload | undefined>(
  ActionType.GET_MANY_SAMPLES
);

const retrieveManySamplesById = createAction<GetManySamplesByIdPayload | undefined>(
  ActionType.GET_MANY_SAMPLES_BY_ID
);const

  retrieveManySamplesByLoinc = createAction<GetManySamplesByLoincPayload | undefined>(
  ActionType.GET_MANY_SAMPLES_BY_LOINC
);

export const useActions = () => {
  const dispatch = useDispatch();
  return bindActionCreators(
    {
      setPrice,
      createSample,
      updateSample,
      deleteSample,
      cusomtRequest,
      importSamples,
      exportSamples,
      retrieveSample,
      placeCustomRequest,
      retrieveManySamples,
      retrieveManySamplesById,
      retrieveManySamplesByLoinc,
    },
    dispatch
  );
};

export const sagaActions = {
  setPrice,
  createSample,
  updateSample,
  deleteSample,
  cusomtRequest,
  importSamples,
  exportSamples,
  retrieveSample,
  placeCustomRequest,
  retrieveManySamples,
  retrieveManySamplesById,
  retrieveManySamplesByLoinc,
};
